module.exports = __webpack_public_path__ + "assets/TowerHouse.4e6f7545.mtl";